<template>
    <div class="card">
        <div class="card-image" v-on:click="markImage">
            <button v-if="addable && !images[imageId]" class="cart-icon cart-icon-button icon-only-button" v-on:click.stop="addToBasket">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path d="M13.299 3.74c-.207-.206-.299-.461-.299-.711 0-.524.407-1.029 1.02-1.029.262 0 .522.1.721.298l3.783 3.783c-.771.117-1.5.363-2.158.726l-3.067-3.067zm3.92 14.84l-.571 1.42h-9.296l-3.597-8.961-.016-.039h9.441c.171-.721.459-1.395.848-2h-14.028v2h.643c.535 0 1.021.304 1.256.784l4.101 10.216h12l1.21-3.015c-.698-.03-1.367-.171-1.991-.405zm-6.518-14.84c.207-.206.299-.461.299-.711 0-.524-.407-1.029-1.02-1.029-.261 0-.522.1-.72.298l-4.701 4.702h2.883l3.259-3.26zm8.799 4.26c-2.484 0-4.5 2.015-4.5 4.5s2.016 4.5 4.5 4.5c2.482 0 4.5-2.015 4.5-4.5s-2.018-4.5-4.5-4.5zm2.5 5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"/></svg>
            </button>
            <span v-if="addable && images[imageId]" class="cart-icon" v-on:click.stop="addToBasket">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path d="M13.299 3.74c-.207-.206-.299-.461-.299-.711 0-.524.407-1.029 1.02-1.029.262 0 .522.1.721.298l3.783 3.783c-.771.117-1.5.363-2.158.726l-3.067-3.067zm3.92 14.84l-.571 1.42h-9.296l-3.597-8.961-.016-.039h9.441c.171-.721.46-1.395.848-2h-14.028v2h.643c.535 0 1.021.304 1.256.784l4.101 10.216h12l1.211-3.015c-.699-.03-1.368-.171-1.992-.405zm-6.518-14.84c.207-.206.299-.461.299-.711 0-.524-.407-1.029-1.02-1.029-.261 0-.522.1-.72.298l-4.701 4.702h2.883l3.259-3.26zm8.799 4.26c-2.486 0-4.5 2.015-4.5 4.5s2.014 4.5 4.5 4.5c2.484 0 4.5-2.015 4.5-4.5s-2.016-4.5-4.5-4.5zm-.469 6.484l-1.688-1.637.695-.697.992.94 2.115-2.169.697.696-2.811 2.867z"/></svg>
            </span>
            <figure class="image" ref="image" v-on:click.stop="showBig">
                <img v-bind:src="'/api/images/' + imageId + '/thumb'" class="ii-image">
                <!--<canvas ref="canvas"></canvas>-->
            </figure>
        </div>
        <div class="card-content">
            <table class="imageinfo-table">
                <tbody>
                <tr>
                    <th>Aufgenommen:</th>
                    <td>{{ image.takenDate.toLocaleString("de") }}</td>
                </tr>
                <tr>
                    <th>Kamera:</th>
                    <td>{{ image.camera }}</td>
                </tr>
                <tr>
                    <th>Objektiv:</th>
                    <td>{{image.lensMake}} {{image.lensModel}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import rpc from '../rpc';
import preScaleImg from '../imgScale';
import {mapState} from 'vuex';

export default {
    props: ["imageId", "addable"],
    data() {
        return {
            image: {
                orientation: "Horizontal (normal)",
                takenDate: new Date(),
                camera: "",
                lensMake: "",
                lensModel: ""
            }
        }
    },
    created() {
        this.getImageObj()
    },
    computed: {
        ...mapState("basket", ["images"])
    },
    methods: {
        async getImageObj() {
            let image = await rpc.request("ImageService.ImageByID", this.imageId)
            image.takenDate = new Date(image.taken);
            this.image = image;
            this.$forceUpdate();
        },
        showBig() {
            this.$store.dispatch("showBigImage", this.image);
        },
        markImage() {
            console.log("marked image", this.imageId)
        },
        addToBasket() {
            this.$store.commit("basket/addImage", this.imageId);
        }
    }
}
</script>
